export function getFacebookError(resp: any): string {
  // 1) User-friendly messages
  const e = resp?.errorObj?.error;
  if (e) {
    if (e.error_user_title && e.error_user_msg) {
      return `${e.error_user_title}: ${e.error_user_msg}`;
    }
    // for example: "Invalid parameter: Invalid parameter: Invalid parameter"
    if (e.error_user_msg) {
      return e.error_user_msg;
    }
    if (e.error_user_title) {
      return e.error_user_title;
    }
    // Technical error message
    if (e.message && e.message !== 'Invalid parameter') {
      return e.message;
    }
  }

  // 3) Top level error message
  if (typeof resp.message === 'string' && resp.message.trim() && resp.message !== ':') {
    return resp.message;
  }

  // All other errors
  return 'Unexpected error. Please try again later.';
}
